import {axiosGet, urlGenerator} from "../common/Helper/AxiosHelper";
import {localTimeZone} from "../common/Helper/Support/DateTimeHelper";

if (window.user) {
    let check = 1;
    let checkAlert = () => {
        axiosGet(`punch-in-alert?timeZone=${localTimeZone}`).then(({data}) => {
            if (data.showAlert && check !== 1) {
                // The server says which action is missing: punch in (shift started, not tracking)
                // or punch out (still tracking after the shift ended).
                const action = data.action === 'punch_out' ? 'punch_out' : 'punch_in';
                if (data.alert_area?.includes('web')){
                    swal(data.message, action);
                }
                if (data.alert_area?.includes('system')){
                    notifySystem(data.message);
                }
            }
            if (data.punchInAlert) {
                check++;
                setTimeout(checkAlert, Number(data.interval) * 1000);
            }
        }).catch((error) => {
            console.log(error?.response?.data?.message || error?.message);
        })
    }
    checkAlert();
}


function swal(message, action = 'punch_in', colorCode = "#0d8cef", showConfirm = true) {
    // Never stack a second alert on top of one that is still open, and stay out of the way
    // while the employee is already in the middle of punching in/out.
    if (Swal.isVisible() || document.getElementById('punch-in-modal')) {
        return;
    }

    Swal.fire({
        title: "Attention!",
        text: message,
        showCancelButton: true,
        confirmButtonColor: `${colorCode}`,
        showConfirmButton: showConfirm,
        confirmButtonText: action === 'punch_out' ? 'Punch out' : 'Punch in',
        cancelButtonText: 'Cancel',
        footer: `<a href="${urlGenerator("/dashboard")}">Open dashboard</a>`,
        imageWidth: 100,
        imageHeight: 70,
        imageAlt: "Warning"
    }).then(function (response) {
        if (response.value) {
            // Open the matching dialog right here — no need to go to the dashboard.
            // GlobalPunchIn re-checks the real punch state before it opens anything.
            window.dispatchEvent(new Event(action === 'punch_out' ? 'open-punch-out' : 'open-punch-in'));
        }
    });
}

function notifySystem(message){
    Notification.requestPermission().then((permission)=>{
        if (permission === 'granted'){
            const notification = new Notification(message, {
                icon: urlGenerator(window.settings.tenant_icon)
            });

            notification.addEventListener("click", () => {
                window.focus();
                window.location = urlGenerator("/dashboard");
            })
        }
    })
}
